export default {
  methods: {
    deepFreeze(target) {
      if (target === null || target === 'undefined' || typeof target !== 'object') return;
      Object.keys(target).forEach(key => {
        this.deepFreeze(target[key]);
      });
      Object.freeze(target);
      return target;
    },
  },
};
